export const SUPPORT_WEB_WIDGET_TOGGLE = 'SUPPORT_WEB_WIDGET_TOGGLE'; // support initilizing is starting
export const SUPPORT_WEB_WIDGET_CLOSE_LISTENER = 'SUPPORT_WEB_WIDGET_CLOSE_LISTENER'; // set close listener just once
export const SUPPORT_WEB_WIDGET_CLOSE_BY_BACK = 'SUPPORT_WEB_WIDGET_CLOSE_BY_BACK'; // close support by back
export const SUPPORT_WEB_WIDGET_WILL_UNMOUNT = 'SUPPORT_WEB_WIDGET_WILL_UNMOUNT'; // will un mount
export const NAVIGATE_TO_SUPPORT = "NAVIGATE_TO_SUPPORT";
